import { useState, useEffect } from "react";
import { getHomeData } from "@/api/homeApi";
import { readHomePreload } from "@/utils/homePreload";

export default function AdvantagesSection() {
  const [advantages, setAdvantages] = useState<any[]>(
    () => readHomePreload()?.advantages?.map((a: any) => ({ ...a, desc: a.description || a.desc })) ?? [],
  );

  useEffect(() => {
    getHomeData().then((res: any) => {
      if (res.advantages) setAdvantages(res.advantages.map((a: any) => ({ ...a, desc: a.description || a.desc })));
    }).catch(() => {});
  }, []);
  return (
    <section className="py-10 lg:py-20 bg-[#f8fafc]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        {/* Header */}
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-[#1a56db]/8 border border-[#1a56db]/20 rounded-full mb-4">
            <span className="text-[#1a56db] text-xs font-medium">为什么选择我们</span>
          </div>
          <h2 className="text-3xl lg:text-4xl font-bold text-[#0d1f3c] mb-4">
            欧格登智能 · 全方位信息安全保障体系
          </h2>
          <p className="text-gray-500 text-base max-w-2xl mx-auto">
            欧格登深耕信息安全领域10余年，以专业技术能力和丰富行业经验，为企业构建坚不可摧的数字安全防线。
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {advantages.map((item, idx) => (
            <div
              key={item.id}
              className="group bg-white rounded-2xl p-8 border border-gray-100 hover:border-[#1a56db]/20 hover:-translate-y-1 hover:shadow-lg transition-all duration-300 cursor-pointer"
              style={{ animationDelay: `${idx * 80}ms` }}
            >
              <div className="w-14 h-14 flex items-center justify-center rounded-xl bg-[#1a56db]/8 mb-6 group-hover:bg-[#1a56db]/15 transition-colors duration-300">
                <i className={`${item.icon} text-2xl text-[#1a56db]`}></i>
              </div>
              <h3 className="text-lg font-semibold text-[#0d1f3c] mb-3">{item.title}</h3>
              <p className="text-sm text-gray-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
